import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@mui/styles';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { loadCordova } from 'utils/Plugins';

// ==============================|| APP ||============================== //

const App = () => {
    // Configure JSS
    const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
    jss.use(rtl());

    const customization = useSelector((state) => state.customization);

    useEffect(() => {
        loadCordova();
    }, []);

    return (
        <StylesProvider jss={jss}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={themes(customization)}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Routes />
                    </NavigationScroll>
                </ThemeProvider>
            </StyledEngineProvider>
        </StylesProvider>
    );
};

export default App;
